<template>
  <div class="ui row container">
    <select class="ui dropdown">
      <option
        v-for="n in 12"
        :key="n"
        :value="n"
      >
        {{ doubleDigit(n) }}
      </option>
    </select>
    <span>:</span>
    <select class="ui dropdown">
      <option
        v-for="n in 60"
        :key="n"
        :value="n"
      >
        {{ doubleDigit(n-1) }}
      </option>
    </select>
    <span>:</span>
    <select class="ui dropdown">
      <option value="am">
        AM
      </option>
      <option value="pm">
        PM
      </option>
    </select>
    <h4>To</h4>
    <select class="ui dropdown">
      <option
        v-for="n in 12"
        :key="n"
        :value="n"
      >
        {{ doubleDigit(n) }}
      </option>
    </select>
    <span>:</span>
    <select class="ui dropdown">
      <option
        v-for="n in 60"
        :key="n"
        :value="n"
      >
        {{ doubleDigit(n-1) }}
      </option>
    </select>
    <span>:</span>
    <select class="ui dropdown">
      <option value="am">
        AM
      </option>
      <option value="pm">
        PM
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'Timepicker',
  methods: {
    doubleDigit: function (n) {
      return n > 9 ? '' + n : '0' + n
    },
  },
}
</script>

<style scoped>
.timepicker-container {
  display: flex;
  flex-direction: row;
}
</style>
